import { useEffect } from 'react';

export const useCloseOnEscape = (isOpen: boolean, onClose: () => void) => {
	useEffect(() => {
		if (isOpen) {
			window.addEventListener('keydown', handleKeyDown);
		}

		// Cleanup the event listener on component unmount or when dialog is closed
		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [isOpen, onClose]);

	const handleKeyDown = (event: KeyboardEvent) => {
		if (event.key === 'Escape') {
			onClose(); // Close the dialog when "Escape" is pressed
		}
	};
};
